<div class="chart-wrapper" *ngIf="data">
  <div class="bars-container" [style.padding-top.px]="getTopPadding()">
    <div class="bars-track">
      <div class="connector-line"
           *ngIf="shouldShowConnector() && !isFirstBarMode()"
           [style.bottom.px]="getConnectorBottom()"></div>

      <div class="first-bar-overlay" *ngIf="shouldShowConnector() && isFirstBarMode()">
        <div class="first-bar-trunk"
             [style.bottom.px]="getTipBottom(0)"
             [style.height.px]="getFirstBarTrunkHeight()"></div>

        <div class="first-bar-branch"
             *ngFor="let value of values; let i = index"
             [style.display]="i > 0 && hasComparison(i) ? 'block' : 'none'"
             [style.bottom.px]="getFirstBarBranchBottom(i)"
             [style.width]="getFirstBarBranchWidth(i)">
          <div class="first-bar-line"></div>
          <div class="first-bar-right-stem"
               [style.height.px]="getFirstBarRightStemHeight(i)"></div>
          <div class="pair-bubble first-bar-bubble"
               *ngIf="shouldShowComparisonBubbles()"
               [style.bottom.px]="getFirstBarBubbleBottom(i)">
            {{ formatPercent(getBarComparison(i)!) }}
          </div>
        </div>
      </div>

      <div class="bar-block"
           *ngFor="let value of values; let i = index">

        <div class="bar-tip"
             *ngIf="shouldShowConnector() && !isFirstBarMode()"
             [style.bottom.px]="getTipBottom(i)"
             [style.height.px]="getTipHeight(i)"></div>

        <div class="pair-bubble"
             *ngIf="shouldShowConnector() && shouldShowComparisonBubbles() && !isFirstBarMode() && hasComparison(i)"
             [style.bottom.px]="getBubbleOnConnectorBottom()">
          {{ formatPercent(getBarComparison(i)!) }}
        </div>

        <div class="pair-bubble top-bubble"
             *ngIf="!shouldShowConnector() && shouldShowComparisonBubbles() && hasComparison(i)">
          {{ formatPercent(getBarComparison(i)!) }}
        </div>

        <div class="value" *ngIf="shouldShowValues()">{{ value }}</div>
        <div class="bar"
             [style.background]="getBarColor(i)"
             [style.height.px]="getBarHeight(value)">
        </div>
        <div class="label" *ngIf="shouldShowLabels()">{{ labels[i] }}</div>
      </div>
    </div>
  </div>
  <div class="axis-label" *ngIf="getBottomLabel()">{{ getBottomLabel() }}</div>
</div>
